export default __webpack_public_path__ + "static/media/Homepage_01.48ffddda.jpg";